import axios from 'axios';
import { BASE_URL, TENANT_DOMAIN, TASKS_API_URL } from '../../config';
import { getToken, setActiveProjectId } from '../../core/services/authService';
import { showSuccessSnackbar, showErrorSnackbar } from './appActions';
import { isObjectEmpty } from '../../core/services/commonService';

const getHeaders = () => ({
  'X-Tenant-ID': TENANT_DOMAIN,
  Authorization: `Bearer ${getToken()}`,
});

export const LOAD_PROJECTS = 'LOAD_PROJECTS';
export const SET_ACTIVE_PROJECT = 'SET_ACTIVE_PROJECT';
export const OPEN_PROJECTS_DIALOG = 'OPEN_PROJECTS_DIALOG';

export const loadProjects = () => async dispatch => {
  try {
    const response = await axios.get(`${BASE_URL}/projects/`, { headers: getHeaders() });
    dispatch({ type: LOAD_PROJECTS, payload: response.data });
  } catch (error) {
    dispatch(showErrorSnackbar('Failed to fetch projects.'));
  }
};

export const getUserPreferences = () => async dispatch => {
  try {
    const response = await axios.get(`${BASE_URL}/users/my-preferences`, { headers: getHeaders() });
    const project = response.data.workspace_project;

    if (project && !isObjectEmpty(project)) {
      dispatch({ type: SET_ACTIVE_PROJECT, payload: { id: project.id, name: project.name } });
    } else {
      dispatch({ type: SET_ACTIVE_PROJECT, payload: null });
    }
  } catch (error) {
    dispatch(showErrorSnackbar('Failed to fetch user preferences.'));
  }
};

export const updateUserPreferences = (projectId, projectName) => async dispatch => {
  try {
    const preferencesResponse = await axios.get(`${BASE_URL}/users/my-preferences`, {
      headers: getHeaders(),
    });

    const preferenceId = preferencesResponse.data.id;
    if (!preferenceId) {
      throw new Error('User preference ID not found.');
    }

    await axios.put(
      `${BASE_URL}/users/preferences/${preferenceId}`,
      { workspace_project: { id: projectId, name: projectName } },
      { headers: getHeaders() },
    );

    if (projectId && projectName) {
      dispatch({ type: SET_ACTIVE_PROJECT, payload: { id: projectId, name: projectName } });
    } else dispatch({ type: SET_ACTIVE_PROJECT, payload: null });
  } catch (error) {
    dispatch(showErrorSnackbar('Failed to update active project.'));
  }
};

export const addProject = projectName => async dispatch => {
  try {
    const response = await axios.post(`${BASE_URL}/projects/`,
      { name: projectName.trim() },
      { headers: getHeaders() });
    dispatch(showSuccessSnackbar(`Project "${response.data.name}" added successfully!`));
    dispatch(loadProjects());
  } catch (error) {
    dispatch(showErrorSnackbar('Failed to add project.'));
  }
};

export const fetchActiveProject = () => async dispatch => {
  try {
    const preferencesResponse = await axios.get(`${BASE_URL}/users/my-preferences`, {
      headers: getHeaders(),
    });

    const project = preferencesResponse.data.workspace_project;
    if (project && !isObjectEmpty(project)) {
      dispatch({ type: SET_ACTIVE_PROJECT, payload: { id: project.id, name: project.name } });
    } else {
      dispatch({ type: SET_ACTIVE_PROJECT, payload: null });
    }

    setActiveProjectId(project.id);
  } catch (error) {
    dispatch(showErrorSnackbar('Failed to fetch active project.'));
  }
};

export const openProjectsDialog = () => async dispatch => {
  try {
    const response = await axios.get(`${BASE_URL}/projects/`, {
      headers: getHeaders(),
    });
    dispatch({ type: OPEN_PROJECTS_DIALOG, payload: response.data || [] });
  } catch (error) {
    dispatch(showErrorSnackbar('Error fetching projects.'));
  }
};

export function updateTaskProject(taskId, selectedProjectId) {
  return function (dispatch) {
    const body = {
      data: {
        type: 'task',
        id: taskId,
        attributes: {
          project_id: selectedProjectId,
        },
      },
    };

    return axios.put(`${TASKS_API_URL}/tasks/${taskId}/project`, body, { headers: getHeaders() })
      .then(res => res.data.data)
      .catch(() => {
        dispatch(showErrorSnackbar('Failed to update project.'));
        return Promise.reject();
      });
  };
}
